<template>
  <v-expansion-panels
    v-model="courseInfoActive"
    class="my-4 participant-course-info-panel"
    background-color="transparent"
  >
    <v-expansion-panel>
      <v-expansion-panel-header>
        <h5 class="bhBlack--text mb-0">Course: {{ course.title }}</h5>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row>
          <v-col>
            <labeled-value label="Thumbnail">
              <v-avatar
                width="56"
                height="56"
                rounded
                class="participant-course-info-panel__thumbnail mr-3"
              >
                <v-img :src="thumbnail" />
              </v-avatar>
            </labeled-value>
          </v-col>
          <v-col>
            <labeled-value label="Author" :value="authorName" />
          </v-col>
          <v-col>
            <labeled-value label="Rating">
              <div class="d-flex align-center">
                <rating-stars
                  color="#945EFF"
                  :rating="course.rating"
                  :size="12"
                />&nbsp;<strong>{{ course.rating }}</strong>
              </div>
            </labeled-value>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <labeled-value
              label="Steps"
              :value="`${course.stepsCompleted} / ${course.steps}`"
            />
          </v-col>
          <v-col>
            <labeled-value
              label="Enrolled Date"
              :value="currentCourseEnrolledDate"
            />
          </v-col>
          <v-col>
            <labeled-value label="Status">
              <dot-status
                :status="course"
                :completePercentage="course.completePercentage"
              />
            </labeled-value>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <labeled-value label="Description" :value="course.description" />
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import LabeledValue from '@/components/labeledValue/LabeledValue.vue'
import RatingStars from '@/components/exercises/RatingStars.vue'
import DotStatus from '@/components/statuses/DotStatus.vue'
import { mapState } from 'vuex'

export default {
  name: 'ParticipantCourseInfoPanel',
  components: { LabeledValue, RatingStars, DotStatus },
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    courseInfoActive: false,
  }),
  methods: {},
  computed: {
    ...mapState('userStates', ['user']),
    thumbnail() {
      return (
        this.course?.staticMediaThumbnailUrl ||
        this.course?.thumbnailUrl ||
        require('@/assets/placeholder_other.png')
      )
    },
    authorName() {
      const creator = this.currentCourse ? this.course.createdBy : this.user

      if (!creator) return 'Unknown'

      let fullName = ''
      fullName += creator?.firstname || creator?.firstName || ''

      if (fullName !== 0) fullName += ' '
      fullName += creator?.lastname || creator?.lastName || ''

      return fullName
    },
    currentCourseEnrolledDate() {
      if (!this.course?.enrolledDate) return '-'
      return this.$moment(this.course.enrolledDate).format(
        'MMMM Do, YYYY hh:mm A',
      )
    },
  },
}
</script>

<style lang="scss"></style>
